const parseAgentSkillMarkdown = (value = '', filename = '') => {
	const markdown = value.replace(/\r\n?/g, '\n').trim();
	const frontmatter = markdown.startsWith('---\n') ? markdown.slice(4, markdown.indexOf('\n---\n', 4)) : '';
	const field = key => frontmatter.match(new RegExp(`^${key}:\\s*["']?(.*?)["']?\\s*$`, 'm'))?.[1]?.trim();
	const heading = markdown.match(/^#\s+(.+)$/m)?.[1]?.trim();
	const name = field('name') || heading || filename.replace(/\.md$/i, '').replace(/[-_]+/g, ' ').trim();
	const body = markdown.replace(/^---\n[\s\S]*?\n---\n/, '').replace(/^#\s+.+$/m, '');
	const description =
		field('description') ||
		body
			.split(/\n\s*\n/)
			.map(item => item.trim())
			.find(item => item && !item.startsWith('#') && !item.startsWith('-')) ||
		'';
	const errors = [];
	if (!markdown) errors.push('Add SKILL.md content to continue.');
	if (markdown && markdown.length < 10) errors.push('The skill document is too short.');
	if (markdown.length > 500_000) errors.push('SKILL.md files must be smaller than 500 KB.');
	if (markdown.startsWith('---\n') && !markdown.includes('\n---\n', 4))
		errors.push('The front matter is missing its closing delimiter.');
	if (markdown && !name) errors.push('Include a name in front matter, an H1 heading, or a descriptive filename.');
	return { description, errors, markdown: markdown ? `${markdown}\n` : '', name };
};

export { parseAgentSkillMarkdown };
